import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query order($ids: [String], $for_admin: Int) {
        order(ids: $ids, for_admin: $for_admin) {
          data {
            address {
              pfu
              lat
              lng
              title
              tellphone
              postal_code
              main_street
              minor_address
            }
            shipping {
              type {
                id
                title
              }
            }
            tracks {
              lat
              lng
              updated_at
            }
            media {
              full_url
            }
            carrier {
              id
              user {
                id
                firstname
                lastname
                cellphone
                media {
                  full_url
                }
              }
            }
            status {
              id
              title
            }
            fast_send
            created_at
            demand_time
            delivery_time
            shipping_code
          }
        }
      }
    `,
  },
  update: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder(
        $ids: [String]!
        $fast_send: Int
        $demand_time: String
        $delivery_time: String
        $shipping_id: String
        $shipping_code: String
        $carrier_id: String
      ) {
        updateOrder(
          ids: $ids
          fast_send: $fast_send
          demand_time: $demand_time
          delivery_time: $delivery_time
          shipping_id: $shipping_id
          shipping_code: $shipping_code
          carrier_id: $carrier_id
        ) {
          model {
            id
          }
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
